import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconStarHalf = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconStarHalf",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M480-675v312l126 77-33-144 111-96-146-13zm0 406L314-169q-11 7-23 6t-21-8-14-17-2-24l44-189-147-127q-10-9-12-20t1-23 12-18 22-9l194-17 75-178q5-12 16-18t21-6 22 6 15 18l75 178 194 17q14 2 22 9t12 18 2 23-13 20L662-401l44 189q3 13-2 24t-14 17-21 8-23-6z"
  })
}));